import { render, staticRenderFns } from "./terminate.vue?vue&type=template&id=5e5727e3&scoped=true"
import script from "./terminate.vue?vue&type=script&lang=js"
export * from "./terminate.vue?vue&type=script&lang=js"
import style0 from "./terminate.vue?vue&type=style&index=0&id=5e5727e3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5727e3",
  null
  
)

export default component.exports